import { createElement } from 'react'
import i18next from 'i18next'
import { I18nextProvider, initReactI18next, useTranslation, withTranslation } from 'react-i18next'

// scripts/loadI18n.js 가 prebuild 에서 받아 두는 파일. 언어당 10KB 안팎이라 번들에 넣는다
import ko from './public/nextjs/static/languages/ko/common.json'
import en from './public/nextjs/static/languages/en/common.json'

// next-i18next@7 설정을 그대로 옮겼다. 언어 감지는 서버·브라우저 모두 꺼져 있어
// 항상 ko 로 시작하고, 바꾸는 곳은 i18n.changeLanguage 를 직접 부르는 페이지뿐이다
const i18n = i18next.createInstance()

i18n.use(initReactI18next).init({
  resources: { ko: { common: ko }, en: { common: en } },
  lng: 'ko',
  fallbackLng: 'ko',
  supportedLngs: ['ko', 'en'],
  lowerCaseLng: true,
  load: 'languageOnly',
  ns: ['common'],
  defaultNS: 'common',
  keySeparator: '::',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  initImmediate: false,
})

const appWithTranslation = App => {
  const AppWithTranslation = props => createElement(I18nextProvider, { i18n }, createElement(App, props))
  AppWithTranslation.getInitialProps = App.getInitialProps
  return AppWithTranslation
}

export { i18n, appWithTranslation, withTranslation, useTranslation }
